import { Component, EventEmitter, OnInit, Output, Input } from "@angular/core";
import { BranchService } from "../../../services/branch.service";
import { AuthService } from "../../../auth.service";
import { BehaviorSubject } from "rxjs";
import { Messages } from "../../../model/messages";
import { Branch } from "../../../model/branches";
import { Router } from "@angular/router";
import { BranchDetailsService } from "../../../services/branch-details.service";
import { Navigation } from "../../../model/navigation";
import { SingleChoice } from "../../../model/singlechoice";

@Component({
    selector: "branches",
    templateUrl: "./branches.component.html",
    styleUrls: ["./branches.component.css"],
})
export class BranchesComponent implements OnInit {
    branchCount: number = 0;
    messages: BehaviorSubject<Messages>;
    branches: BehaviorSubject<Branch[]>;
    filteredBranch: BehaviorSubject<Branch[]> = new BehaviorSubject<Branch[]>([]);
    searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>("");
    @Output() branchSelected = new EventEmitter<number>();
    @Output() createNew = new EventEmitter<void>();
    @Input() isMobile: boolean = false;
    @Input() choiceEvent: SingleChoice = SingleChoice.EMPTY;
    title: BehaviorSubject<string> = new BehaviorSubject<string>("");
    constructor(
        private branchService: BranchService,
        private auth: AuthService,
        private router: Router,
        private branchDetails: BranchDetailsService
    ) {
        this.messages = new BehaviorSubject(Messages.EMPTY);
        this.branches = new BehaviorSubject<Branch[]>(
            this.branchService.branchesData
        );
    }

    ngOnInit(): void {
        this.title.next("branches.title");
        const token = this.auth.token;
        this.branchService.branches(token).subscribe({
            next: (messages) => {
                if (messages.hasAnyMessages) {
                    this.messages.next(messages);
                }
            },
            complete: () => { },
        });
        this.branchService.branchesObservable.subscribe((data) => {
            // by abbreviation, and by name those without one, rather than all of those first
            const sortedBranches = data.sort((a: Branch, b: Branch) =>
                BranchService.shortName(a).localeCompare(BranchService.shortName(b))
            );
            this.branches.next(sortedBranches);
            this.filteredBranch.next(sortedBranches);
            this.branchCount = sortedBranches.length;
        });
    }

    searchBranches(): void {
        const query = (this.searchTerm.getValue() || '').toLowerCase();

        // the abbreviation's start, or anywhere in the name: a location without an
        // abbreviation could not be found at all
        const filtered = this.branches.value.filter(branch =>
            (branch.abbreviation || '').toLowerCase().startsWith(query) ||
            (branch.name || '').toLowerCase().includes(query)
        );

        this.filteredBranch.next(filtered);
    }

    clearBranchFilter(): void {
        this.searchTerm.next("");
        this.filteredBranch.next(this.branches.value);
    }
    select(branch: Branch) {
        if (this.choiceEvent && this.choiceEvent.topic == "branches") {
            if (branch && branch.id) {
                this.branchService.makeBackgroundColor(branch.id).subscribe((color) => {
                    const background = color;
                    this.branchService.makeColor(branch.id!!).subscribe((c) => {
                        const color = c;
                        this.choiceEvent.choose(
                            branch.id!!,
                            branch.name,
                            background,
                            color,
                            1
                        );
                    });
                });
            }
        } else {
            this.branchDetails.select(branch);
            if (branch && branch.id) {
                this.router.navigate([`branches/${branch.id}`]).then(() => {
                    this.branchSelected.emit(branch.id!!);
                });
            }
        }
    }

    createNewBranch() {
        this.createNew.emit();
        const newBranch = new Branch(Navigation.NEW, "", "");
        this.branchDetails.select(newBranch);
        this.router.navigate([`branches/` + Navigation.NEW]).then(() => {
            this.branchSelected.emit(Navigation.NEW);
        });
    }

    public get selected(): Branch {
        return this.branchDetails.selected;
    }
}
